import styled from 'styled-components';

export const StyledOtpInput = styled.input<{
  dataValue: string;
  error: boolean;
}>`
  font-family: AliBabaRE;
  border: none;
  line-height: 50px;
  border-radius: 0;
  height: 50px;
  flex: 1;
  border-bottom: ${({ theme }): string => theme.borders[0]};
  border-color: ${({ theme }): string => theme.colors.normalText};
  color: ${({ theme, error }): string =>
    error ? theme.colors.danger : theme.colors.normalText};
  font-size: ${({ theme }): string => theme.fontSizes[20]};
  text-align: left;
  direction: rtl;
  outline: none;
  caret-color: ${({ theme, dataValue }): string =>
    !dataValue.length ? theme.colors.normalText : 'transparent'};

  user-select: none;
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  [type='number'] {
    -moz-appearance: textfield;
  }
`;
